import { useState } from 'react';
import { isSoundEnabled, setSoundEnabled, playSound } from '../lib/sound';
import { useTranslation } from '../i18n';

/** 효과음 On/Off 토글 (theme-toggle 와 동일 시각 언어). */
export function SoundToggle() {
  const { t } = useTranslation();
  const [on, setOn] = useState(isSoundEnabled());

  function toggle() {
    const next = !on;
    setSoundEnabled(next);
    setOn(next);
    if (next) playSound('correct'); // 켤 때 짧은 확인음
  }

  return (
    <button
      type="button"
      className="theme-toggle"
      onClick={toggle}
      aria-label={`${t('sound.label')}: ${on ? t('sound.on') : t('sound.off')}`}
      aria-pressed={on}
      title={on ? t('sound.on') : t('sound.off')}
    >
      <span aria-hidden="true" className="theme-toggle__icon">
        {on ? (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
            <path d="M11 5 6 9H2v6h4l5 4V5z" /><path d="M15.5 8.5a5 5 0 0 1 0 7M19 5a9 9 0 0 1 0 14" />
          </svg>
        ) : (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
            <path d="M11 5 6 9H2v6h4l5 4V5z" /><path d="M23 9l-6 6M17 9l6 6" />
          </svg>
        )}
      </span>
    </button>
  );
}
